import { MapPin, Phone, Navigation, Clock } from "lucide-react";
import { BUSINESS } from "../lib/business";

const Q = encodeURIComponent(`Speedway Earlwood, ${BUSINESS.address}, Australia`);
const MAP_EMBED = `https://maps.google.com/maps?q=${Q}&z=16&output=embed`;
const DIRECTIONS = `https://www.google.com/maps/dir/?api=1&destination=${Q}`;

export function SiteFooter() {
  return (
    <footer className="border-t border-white/10 bg-surface" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 py-14 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <div className="overline text-volt mb-3 flex items-center gap-2"><MapPin className="w-4 h-4" /> Find Us</div>
          <p className="font-head font-bold text-2xl uppercase tracking-tight">{BUSINESS.site}</p>
          <p className="text-sm text-muted-foreground mt-1">{BUSINESS.address}</p>
          <p className="overline text-volt mt-3 flex items-center gap-2" data-testid="footer-station-hours"><Clock className="w-4 h-4" /> {BUSINESS.stationHours}</p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a href={DIRECTIONS} target="_blank" rel="noopener noreferrer" data-testid="footer-directions-btn"
              className="inline-flex items-center gap-2 bg-volt text-white px-6 py-3 font-head font-bold uppercase tracking-wide hover:bg-blue-600 transition-colors">
              <Navigation className="w-4 h-4" /> Get Directions
            </a>
            <a href={BUSINESS.phoneHref} data-testid="footer-phone-link"
              className="inline-flex items-center gap-2 border border-white/20 px-6 py-3 overline hover:border-volt transition-colors">
              <Phone className="w-4 h-4 text-volt" /> {BUSINESS.phone}
            </a>
          </div>
        </div>
        <iframe title="Map to Speedway Earlwood" src={MAP_EMBED} data-testid="footer-map" loading="lazy"
          referrerPolicy="no-referrer-when-downgrade" className="w-full h-72 border border-white/10 grayscale invert-[0.9] hue-rotate-180" />
      </div>
      <div className="border-t border-white/10 py-6 text-center overline text-muted-foreground">
        {BUSINESS.name} — {BUSINESS.site}
      </div>
    </footer>
  );
}
